export default __webpack_public_path__ + "static/logo-3df8632597a64e3eab2af9c669c43579.png";